module.exports = __webpack_public_path__ + "static/img/sjfw.f0f2f1b8.png";